import React from "react"
import { motion } from "motion/react"
import clsx from "clsx"
import styles from "./index.module.scss"

export const DialogBackdrop: React.FC<
    React.PropsWithChildren<{ guideKey?: string }>
> = ({ guideKey, children }) => {
    return (
        <motion.div
            className={clsx(styles.backdrop, !guideKey && styles.noGuide)}
            initial={{ opacity: 0 }}
            animate={{
                opacity: 1,
                transition: { duration: 0.7, ease: [0.33, 1, 0.68, 1] },
            }}
        >
            {guideKey && (
                <div className={styles.main}>
                    <div
                        className={clsx(
                            styles.backdropGuideContent,
                            guideKey === "guide1" && styles.guide1,
                            guideKey === "guide2" && styles.guide2,
                            guideKey === "guide3" && styles.guide3
                        )}
                        data-guide-key={guideKey}
                    />
                    {children}
                </div>
            )}
        </motion.div>
    )
}
